// vm-pagination.js
import { LitElement, html } from 'lit';
import Styles from './vm-kol-profile-page-header.scss';

export default class VmKolHeader extends LitElement {
    static API_BASE_URL = '/api/kol/';
    static styles = Styles;

    static properties = {
        showReadMore: { type: Boolean },
        shareButtonClicked: { type: Boolean },
        kolProfileData: { type: Object },
    };

    constructor() {
        super();
        this.showReadMore = false;
        this.shareButtonClicked = false;
    }

    firstUpdated() {
        this.showReadMore = this.shouldShowReadMore();
    }

    renderSocialButton(link, icon) {
        if (!link || !icon) return null;

        return html`
            <a
                href="${link}"
                class="vm-button vm-button--secondary vm-button--md vm-button--kol-social"
                target="_blank"
            >
                <i class="icon icon-${icon}"></i>
            </a>
        `;
    }

    copyTextHandler = (text) => {
        if (navigator.clipboard) {
            return navigator.clipboard.writeText(text);
        } else {
            const t = document.createElement('textarea');
            t.value = text;
            document.body.appendChild(t);
            t.select();
            document.execCommand('copy');
            document.body.removeChild(t);
        }

        return Promise.resolve();
    };

    handleReadMoreClick = () => {
        this.showReadMore = false;
    };

    handleShareButtonClick = (ev) => {
        ev.preventDefault();
        const shareUrl = window.location.href;

        if (this.shareButtonClicked) return;

        this.copyTextHandler(shareUrl)
            .then(() => {
                this.shareButtonClicked = true;

                setTimeout(() => {
                    this.shareButtonClicked = false;
                }, 2000);
            })
            .catch();
    };

    shouldShowReadMore() {
        const isMobile = window.innerWidth < 992;
        const profileBio = this.shadowRoot.querySelector('.js_kolProfileBio');
        const fullHeight = profileBio?.scrollHeight || 0;
        const truncatedHeight = isMobile ? 40 : 48;

        return fullHeight > truncatedHeight;
    }

    render() {
        return html`
            <div class="kol-profile__header">
                <vm-profile-image
                    .imageSrc="${this.kolProfileData.avatar}"
                    .userName="${this.kolProfileData.full_name}"
                ></vm-profile-image>
                <div class="kol-profile__header-text">
                    <h3 class="kol-profile__name">${this.kolProfileData.full_name}</h3>
                    <p class="kol-profile__title">${this.kolProfileData.title}</p>
                </div>
            </div>

            <div class="kol-profile__education-and-workplace">
                ${this.kolProfileData.education
                    ? html`
                          <p class="kol-profile__education">
                              <i class="icon icon-graduation-hat"></i>
                              <span>${this.kolProfileData.education}</span>
                          </p>
                      `
                    : ''}
                ${this.kolProfileData.workplace
                    ? html`
                          <p class="kol-profile__workplace">
                              <i class="icon icon-briefcase"></i>
                              <span>${this.kolProfileData.workplace}</span>
                          </p>
                      `
                    : ''}
            </div>

            <div class="kol-profile__bio js_kolProfileBio ${this.showReadMore ? 'is-truncated' : ''}">
                <p>${this.kolProfileData.short_biography}</p>
                ${this.showReadMore
                    ? html`
                          <button
                              class="vm-button vm-button--text-only vm-button--read-more"
                              @click=${this.handleReadMoreClick}
                          >
                              Read More
                          </button>
                      `
                    : ''}
            </div>

            <div class="kol-profile__buttons-wrap">
                <div class="kol-profile__social-links">
                    ${this.renderSocialButton(this.kolProfileData.linkedin_url, 'linkedin')}
                    ${this.renderSocialButton(this.kolProfileData.youtube_url, 'youtube')}
                    ${this.renderSocialButton(this.kolProfileData.twitter_url, 'x-twitter')}
                    ${this.renderSocialButton(this.kolProfileData.website_url, 'globe')}
                </div>

                <div class="kol-profile__contact-and-share">
                    ${this.kolProfileData.contact_email
                        ? html`
                              <a
                                  href="mailto:${this.kolProfileData.contact_email}"
                                  class="vm-button vm-button--primary vm-button--md vm-button--contact"
                              >
                                  <i class="icon icon-mail-outline"></i>
                                  Contact
                              </a>
                          `
                        : ''}
                    <button
                        class="vm-button vm-button--secondary vm-button--md vm-button--share"
                        @click=${this.handleShareButtonClick}
                    >
                        ${this.shareButtonClicked
                            ? html`
                                  <i class="icon icon-check"></i>
                                  Link Copied!
                              `
                            : html`
                                  <i class="icon icon-share-outline"></i>
                                  Share
                              `}
                    </button>
                </div>
            </div>
        `;
    }
}
